export default __webpack_public_path__ + "static/media/37.1eade642.jpg";